export type MODAL_CONSTANTS = {
  title: string;
  title_after_break: string;
  approve: string;
};

export const EDIT_MODAL: MODAL_CONSTANTS = {
  title: 'Add alt to selected photos',
  title_after_break: '',
  approve: 'Edit',
};
export const DELETE_MODAL: MODAL_CONSTANTS = {
  title: 'Are you sure you want to delete',
  title_after_break: 'selected photos?',
  approve: 'Delete',
};
